<template>
  <div class="menu-sidebar-item" v-if="item.menuType !== 2">
    <template v-if="!hasChildren">
      <app-link :to="item.link" :class="{'is-first-active': isFirstActive(item)}">
        <el-menu-item :index="item.link" class="submenu-title-noDropdown">
          <div class="submenu-box">
            <item :icon="iconClass" :title="menuName" />
          </div>
        </el-menu-item>
      </app-link>
    </template>
    <!-- 原本这里的:index 用的是item.link,但是现在菜单存在urlProfix(产品线应用)一样的情况，bi用的也是OMS(90010)，所以这里不能用menuKey -->
    <el-submenu 
      v-else 
      ref="subMenu" 
      :index="item.menuKey"
      :class="{'is-first-active': isFirstActive(item)}"
      popper-append-to-body 
      popper-class="second-submenu-container"
    >
      <template slot="title">
        <item :icon="iconClass" :title="menuName" />
      </template>
      <el-scrollbar style="height: 100%" wrap-class="second-scrollbar-wrapper">
        <el-menu
          :unique-opened="true"
          :default-active="activeIndex"
        >
          <second-menu
            v-for="(child, k) in item.childNode"
            :key="child.id"
            :is-nest="true"
            :data="child"
            :childIndex="`${index}-${k}`"
            :current-path="currentPath"
            @updateActiveIndex="updateActiveIndex"
          />
        </el-menu>
      </el-scrollbar>
    </el-submenu>
  </div>
</template>

<script>
import Item from './Item.vue'
import AppLink from './Link.vue'
import SecondMenu from './SecondMenu.vue'

export default {
  name: 'SidebarItem',
  components: { Item, AppLink, SecondMenu },
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: String,
      default: ''
    },
    currentPath: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconClass() {
      return this.item.iconClass
    },
    menuName() {
      return this.item.menuName
    },
    hasChildren() {
      const childNode = this.item.childNode || []
      const showChildren = childNode.filter(item => {
        if (item.menuType === 2) {
          return false
        } else {
          return true
        }
      })
      if (showChildren.length === 1) {
        return true
      }
      if (showChildren.length === 0) {
        return false
      }
      return true
    },
    variables() {
      return document.body.style.getPropertyValue('--geek-color-subMenuBar').trim()
    }
  },
  data() {
    return {
      activeIndex: ''
    }
  },
  methods: {
    isFirstActive(v) {
      if (v.menuKey && this.currentPath.includes('/'+v.menuKey)) {
        return true
      } else {
        return false
      }
    },
    updateActiveIndex(val) {
      this.activeIndex = val
    }
  },
}
</script>
<style lang="scss">
@import '../../../../styles/variables.scss';
.el-submenu .el-submenu__title {
  display: flex;
  flex-direction: column;
  height: 54px;
  line-height: 1;
  align-items: center;
  justify-content: center;
}
.nest-menu .menu-item-li-height{
  height: 30px !important;
  line-height: 30px;
}

.yld-sub-menu {
  .el-submenu__title{
    height: 30px;
    line-height: 30px;
    display: flex;
    flex-direction: row;
    text-align: left;
  }
}

.el-menu--popup {
  overflow-y: visible !important;
  .yun-menu-icon {
    font-size: 14px;
    vertical-align: middle;
    margin-right: 20px;
    color:var(--geek-color-menuTextColor) !important;
  }
  .menu-sidebar-item {
    height: auto !important;
  }
  .el-submenu__title, 
  .el-menu-item {
    justify-content: flex-start;
  }
  .el-menu-item:hover{
    background: var(--geek-color-subMenuHover) !important;
  }
}
.el-menu-item {
  height: 54px !important;
  &:hover {
    .yun-menu-icon {
      color: var(--geek-color-menuTextColor);
    }
  }
  align-items: center;
  display: flex;
  justify-content: center;
  span {
    font-size: 14px;
    color: var(--geek-color-menuTextColor);
  }
}
.el-submenu__title {
  color: var(--geek-color-menuTextColor) !important;
  &:hover {
    .yun-menu-icon, i {
      color: var(--geek-color-menuTextColor);
    }
  }
}
.submenu-box {
  align-items: center;
  line-height: 1;
  .yun-menu-icon {
    margin-bottom: 3px;
    color:var(--geek-color-menuTextColor);
  }
}

.second-submenu-container {
  z-index: 4000 !important;
  height: 100vh;
  top: 0 !important;
  transform-origin: center;
  opacity: 1;
  ul {
    padding: 0;
    margin: 0;
  }
  .el-menu--popup {
    height: 100%;
    background: var(--geek-color-subMenuBar) !important;
  }
  .el-menu {
    border-right: none;
  }
}
.second-submenu-container.el-zoom-in-left-enter-active, .second-submenu-container.el-zoom-in-left-leave-active {
   opacity: 1;
  transition: none 0 !important;
  transform: none !important;
}
.second-submenu-container.el-zoom-in-left-enter, .second-submenu-container.el-zoom-in-left-leave {
  opacity: 1;
  transition: none 0 !important;
  transform: none !important;
}
.second-submenu-container.el-zoom-in-left-leave-to {
   opacity: 1;
  transition: none 0 !important;
  transform: none !important;
}
.second-scrollbar-wrapper {
  .el-menu {
    background-color: var(--geek-color-subMenuBar) !important;
  }
  .router-link-active {
    & > .el-menu-item {
        background: var(--geek-color-subMenuHover) !important;
      }
  }
  .el-submenu__title {
    height: 44px;
    line-height: 44px;
  }
  i {
    color: var(--geek-color-menuTextColor) !important;
    font-size: 16px;
  }
   .yun-menu-icon {
     color: var(--geek-color-menuTextColor) !important;
      font-size: 16px;
      margin-right: 13px;
   }
   .el-submenu {
     .el-menu-item {
       color: var(--geek-color-menuTextColor);
       font-size: 14px;
       height: 44px !important;
       line-height: 44px !important;
     }
   }
}
</style>
